export * from './email.service';
import { EmailService } from './email.service';
export * from './geo.service';
import { GeoService } from './geo.service';
export * from './storage.service';
import { StorageService } from './storage.service';
export * from './ticket.service';
import { TicketService } from './ticket.service';
export const APIS = [EmailService, GeoService, StorageService, TicketService];
